import { ReactElement } from 'react';
import styled from 'styled-components';

const Container = styled.span<{ size?: string }>`
  background-color: var(--v3-black-6);
  color: var(--v3-text-color);
  justify-content: center;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  ${props => {
    switch (props.size) {
      case 'md':
        return `
        height: 24px;
        padding: 0 8px;
        min-width: 24px;
        line-height: 24px;
        border-radius: 4px;
      `;
      case 'sm':
      default:
        return `
        height: 16px;
        padding: 2px 6px;
        min-width: 24px;
        min-height: 20px;
        line-height: 16px;
        border-radius: 4px;
      `;
    }
  }}
`;

const Icon = styled.span`
  margin-right: 4px;
`;

type Props = {
  children: any;
  icon?: any;
  size?: 'sm' | 'md';
};

export const Pill = (props: Props): ReactElement => {
  return (
    <Container size={props.size}>
      {props.icon ? (
        <>
          <Icon>{props.icon}</Icon>
          <span>{props.children}</span>
        </>
      ) : (
        props.children
      )}
    </Container>
  );
};
